const Input = (props: any) => {
  return <input className="devugo-input" {...props} />;
};

export default Input;
